export const WEBPAY_START = 'WEBPAY_START';
export const WEBPAY_SUCCESS = 'WEBPAY_SUCCESS';
export const WEBPAY_FAILURE = 'WEBPAY_FAILURE';

export const RESET_WEBPAY = 'RESET_WEBPAY';